import { Box, Card, Container, Typography } from '@mui/material'
import React from 'react'

export default function ResearchFocus() {
    const [isMobile, setIsMobile] = React.useState(window.innerWidth < 720 ? true : false)

    //choose the screen size 
    const handleResize = () => {
        if (window.innerWidth < 720) {
            setIsMobile(true)
        } else {
            setIsMobile(false)
        }
    }

    return (
        <React.Fragment>
            <Box >
                <Container >
                    <Box display={'block'} justifyContent={"center"}>
                        <Typography variant={isMobile ? 'h5' : 'h4'} >
                            Research Focus
                        </Typography>
                        <Container sx={{ width: 80, height: 2, backgroundColor: "black" }} />
                        <br />
                    </Box>
                    <Typography variant='body1' justifyContent={"center"} alignItems={"center"} alignContent={"center"} textAlign={"justify"}>
                        The HPC Nexus Laboratory stands at the forefront of High-Performance Computing  research and explores its diverse applications across various fields. Our research is oriented around addressing the most complex challenges in parallel High Performance Computing, focusing on modern heterogeneous and hybrid compute nodes, complex large-scale heterogeneous clusters, and extreme-scale platforms. We work on the development of models,  algorithms, methods, software tools, systems, and development practices that will facilitate improved utilization of modern and perspective HPC platforms.
                        Additionally, our research tackle today's interdisciplinary computational challenges, such as analyzing Big Data, simulating complex systems, optimizing algorithms, and training compute-intensive ML and DL models for descriptive and predictive analysis, all of which could significantly benefit from HPC.

                    </Typography>
                    <br />                    <br />

                    <Typography variant={isMobile ? 'h5' : 'h4'}>
                        Research Areas
                    </Typography>
                    <Container sx={{ width: 80, height: 2, backgroundColor: "black" }} />
                    <br />
                    <Typography variant='body1' align='left'>
                        <ul style={{ alignItems: 'left', top: -15, position: 'relative' }}>
                            <li>
                                High Performance Computing (HPC) including Supercomputing. Cluster, GRID and Cloud Computing
                            </li>
                            <li>
                                Performance Optimization
                            </li>
                            <li>
                                Energy Optimization
                            </li>
                            <li>
                                AI Revolutionized HPC
                            </li>
                            <li>
                                High Performance Big Data Analytics
                            </li>
                            <li>
                                HPC for Machine Learning
                            </li>
                        </ul>
                    </Typography>

                </Container>
            </Box>
        </React.Fragment>
    )
}
